<script setup>
import { computed, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { ElMenuItem, ElSubMenu, ElIcon, ElDivider } from "element-plus";
import { CogIcon } from "@heroicons/vue/outline";
import { adminPortalMenu } from "../data/dummyLayoutData";
import { getRoles } from "@/composable/users/getRoles.js";

const emit = defineEmits(["navigate"]);

const router = useRouter();
const {
  isSuperAdmin,
  isAccountManager,
  isSpecificManager,
  isMultiStoreManager,
} = getRoles();

// Mirrors the Admin Portal gating in GlobalHeader.vue / AdminPortalMenus.vue
const canView = computed(
  () =>
    isSuperAdmin.value ||
    isAccountManager.value ||
    isSpecificManager.value ||
    isMultiStoreManager.value
);

// Mirrors AdminPortalMenus.vue's `filteredRoutes` per-item role gates.
const childAccess = {
  "manage-curriculums": () => isSuperAdmin.value,
  "manage-courses": () => isSuperAdmin.value || isAccountManager.value,
  "manage-categories": () => isSuperAdmin.value,
  "manage-playlist": () => isSuperAdmin.value || isAccountManager.value,
  "manage-companies": () => isSuperAdmin.value,
  "manage-stores": () =>
    isSuperAdmin.value || isAccountManager.value || isMultiStoreManager.value,
  "manage-assignments": () => isSuperAdmin.value,
  "usage-report": () => isSuperAdmin.value,
};

const visibleChildren = computed(() =>
  adminPortalMenu.children.filter((child) => {
    const check = childAccess[child.key];
    return check ? check() : true;
  })
);

const handleSelect = (child) => {
  emit("navigate");

  if (child.urlType === "central") {
    window.open(child.path, "_blank");
    return;
  }

  router.push({ path: child.path });
};
</script>

<template>
  <template v-if="canView">
    <ElDivider />

    <el-sub-menu :index="adminPortalMenu.key" v-has-restrict-learner>
      <template #title>
        <el-icon>
          <CogIcon class="w-5 h-5" />
        </el-icon>
        <span>{{ adminPortalMenu.label }}</span>
      </template>
      <el-menu-item
        v-for="child in visibleChildren"
        :key="child.key"
        :index="child.key"
        @click="handleSelect(child)"
      >
        {{ child.label }}
      </el-menu-item>
    </el-sub-menu>
  </template>
</template>
